var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 26.25V30H3.75V26.25H8.75ZM21.25 26.25V30H26.25V26.25H21.25ZM29.0263 13.75C28.7913 12.8525 28.5263 11.9638 28.2025 11.0863L25.5225 3.71875C25.2585 2.99626 24.7792 2.37216 24.1493 1.93069C23.5194 1.48921 22.7692 1.25163 22 1.25H8C7.23079 1.25163 6.4806 1.48921 5.8507 1.93069C5.22079 2.37216 4.74149 2.99626 4.4775 3.71875L1.7975 11.0863C1.47875 11.9638 1.20875 12.8525 0.97375 13.75H29.0263ZM30 21.29V23.75H0V21.29C0.00142035 19.6008 0.146106 17.9148 0.4325 16.25H29.5675C29.8539 17.9148 29.9986 19.6008 30 21.29ZM6.25 18.75C5.91848 18.75 5.60054 18.8817 5.36612 19.1161C5.1317 19.3505 5 19.6685 5 20C5 20.3315 5.1317 20.6495 5.36612 20.8839C5.60054 21.1183 5.91848 21.25 6.25 21.25C6.58152 21.25 6.89946 21.1183 7.13388 20.8839C7.3683 20.6495 7.5 20.3315 7.5 20C7.5 19.6685 7.3683 19.3505 7.13388 19.1161C6.89946 18.8817 6.58152 18.75 6.25 18.75ZM23.75 18.75C23.4185 18.75 23.1005 18.8817 22.8661 19.1161C22.6317 19.3505 22.5 19.6685 22.5 20C22.5 20.3315 22.6317 20.6495 22.8661 20.8839C23.1005 21.1183 23.4185 21.25 23.75 21.25C24.0815 21.25 24.3995 21.1183 24.6339 20.8839C24.8683 20.6495 25 20.3315 25 20C25 19.6685 24.8683 19.3505 24.6339 19.1161C24.3995 18.8817 24.0815 18.75 23.75 18.75Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontCar);
export default __webpack_public_path__ + "static/media/front-car.e34477b5.svg";
export { ForwardRef as ReactComponent };